import { clearShareCache } from "@/lib/share";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      if (e.response?.status === 403) { toast.error(formatErr(e)); setUser(false); return; }
      try {
        await api.post("/auth/refresh");
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (e2) {
        setUser(false);
      }
    }
  }, []);

  useEffect(() => {
    // Skip /me while returning from Google OAuth; AuthCallback handles it.
    if (window.location.hash?.includes("session_id=")) return;
    refreshUser();
  }, [refreshUser]);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    clearShareCache();
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, setUser, refreshUser, logout }), [user, refreshUser, logout]);
  useEffect(() => {
    if (user) localStorage.setItem("itz_splash_user", JSON.stringify({ name: (user.name || "").split(" ")[0], points: user.points || 0 }));
    else if (user === false) localStorage.removeItem("itz_splash_user");
  }, [user]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
